/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ap-bill-details-datagrid-content[_ngcontent-%COMP%]{margin-bottom:10px}.margin-right-3px[_ngcontent-%COMP%]{margin-right:3px}.history-icon[_ngcontent-%COMP%]{text-align:right}.history-icon[_ngcontent-%COMP%]     .dx-toolbar .dx-toolbar-items-container{height:16px!important}"];
export { styles as styles };
